import { formatEramMessage, genericAccept, genericReject } from "@poscon/shared-types/eram";
import { baseEramHubConnection } from "./eramHubConnectionFactory";
import { setIsProcessingCommand, setMcaFeedback } from "./eramReact/slices/messagingSlice";
import { dispatchCommandRecall } from "./customEvents";
export function parseSO(msg, client) {
    return async (dispatch) => {
        if (msg.length > 1) {
            dispatch(setMcaFeedback(genericReject(["FORMAT", formatEramMessage(msg)])));
            dispatchCommandRecall();
            return;
        }
        dispatch(setIsProcessingCommand(true));
        if (!baseEramHubConnection.sectorId) {
            dispatch(setMcaFeedback(genericReject(["NOT SIGNED IN"])));
            return;
        }
        try {
            await baseEramHubConnection.signout(client);
            dispatch(setMcaFeedback(genericAccept([`SIGN OUT`])));
        }
        catch (err) {
            if (typeof err === "string") {
                dispatch(setMcaFeedback(genericReject([err.replaceAll("_", " ")])));
            }
            else {
                baseEramHubConnection.dispatch?.(setMcaFeedback(genericReject(["UNKNOWN ERROR"])));
            }
        }
        dispatch(setIsProcessingCommand(false));
        dispatchCommandRecall();
    };
}
//# sourceMappingURL=parseSO.js.map